import { useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { SEO } from "../components/SEO";
import { api } from "../lib/api";

export default function NotFound() {
  const { pathname } = useLocation();
  // Report the 404 to the backend so admin sees it in Redirects → 404 Pages
  // and can decide whether to add a manual redirect. Fire-and-forget; skip
  // internal admin/api paths so we don't spam the tracker.
  useEffect(() => {
    if (!pathname || pathname.startsWith("/admin") || pathname.startsWith("/api/")) return;
    api.post("/redirects/report-404", {
      path: pathname,
      referrer: typeof document !== "undefined" ? document.referrer || "" : "",
    }).catch(() => {});
  }, [pathname]);
  return (
    <div data-testid="not-found-page" className="mx-auto flex min-h-[60vh] max-w-xl flex-col items-center justify-center px-4 text-center">
      <SEO title="404 Not Found | VVS Lab Jewelry" description="Page not found." noindex />
      <p className="font-display text-7xl font-black tracking-tighter text-outline-black">404</p>
      <h1 className="mt-4 font-display text-lg font-bold text-black">This page ain&apos;t iced out</h1>
      <p className="mt-3 text-zinc-600">The link you followed doesn&apos;t exist or was moved.</p>
      <Link to="/" className="mt-8 border-2 border-black bg-black px-10 py-4 text-xs font-bold uppercase tracking-[0.2em] text-white transition-colors duration-200 hover:bg-white hover:text-black">Back Home</Link>
    </div>
  );
}
